import React from 'react';
import { useStaticQuery } from 'gatsby';
import { readableColor } from 'polished';
import * as S from './styles';
import { Button, Link } from '../../elements';
import { jsx as ___EmotionJSX } from "@emotion/react";
const LivePromoCard = _ref => {
  let {
    title,
    image,
    attachment,
    children,
    cta
  } = _ref;
  const {
    theme
  } = useStaticQuery(query);
  const button_color = readableColor(theme.brand_color, '#000', '#fff');
  return ___EmotionJSX(S.Wrapper, null, ___EmotionJSX(S.Card, null, ___EmotionJSX(S.Text, {
    hasImage: image !== null
  }, ___EmotionJSX("h3", {
    className: 'int-title'
  }, title), children, cta && ___EmotionJSX(Button, {
    primary: true,
    accentColor: button_color,
    as: Link,
    to: cta.type === '0' ? cta.link : attachment
  }, cta.display_name)), image && ___EmotionJSX(S.Image, null, ___EmotionJSX("img", {
    src: `${process.env.GATSBY_API_ENDPOINT}/announcements/assets/${image.private_hash}?w=800&h=700&f=contain&q=100`,
    alt: ""
  }))));
};
export default LivePromoCard;
const query = "367178099";